import { observer } from "mobx-react-lite";
import { stringify } from "query-string";
import { FunctionComponent } from "react";

import {
  ContextualMenuItemType,
  IContextualMenuItem,
  PrimaryButton,
  Stack
} from "@bps/fluent-ui";
import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { routes } from "@libs/routing/routes.ts";
import { useStores } from "@stores/hooks/useStores.ts";

export const ADD_ACCOUNT_CREDIT_BTN = "addAccountCredit";

interface BillingButtonsProps {
  contactId?: string;
  hideAccountCredit?: boolean;
}

export const BillingButtons: FunctionComponent<BillingButtonsProps> = observer(
  ({ contactId, hideAccountCredit }) => {
    const { routing, billing, core } = useStores();

    const getBillingMenuItems = () => {
      const items: IContextualMenuItem[] = [];
      items.push(
        {
          key: "new-paymentLink",
          name: "New payment",
          onClick: () =>
            routing.pushWithFromQuery({
              pathname: routes.accounts.allocations.new.pattern,
              search: stringify({ accountId: contactId })
            }),
          showBorder: !contactId
        },
        {
          name: "Add account credit",
          key: "add-account-credit",
          path: routes.accounts.allocations.new,
          onClick: () => {
            routing.pushWithFromQuery(
              {
                pathname: routes.accounts.allocations.new.pattern,
                search: stringify({ accountId: contactId })
              },
              { buttonClicked: ADD_ACCOUNT_CREDIT_BTN }
            );
          },
          filter: !hideAccountCredit
        }
      );

      if (core.hasPermissions(Permission.StatementWrite)) {
        items.push(
          {
            key: "divider1",
            itemType: ContextualMenuItemType.Divider
          },
          {
            name: "New statement",
            key: "new-statement",
            onClick: () => {
              billing.ui.onToggleStatementModal(true);
            }
          }
        );
      }

      items.filter(x => x.filter === undefined || !!x.filter);
      return items;
    };

    return (
      <Stack horizontal styles={{ root: { alignItems: "end" } }}>
        <PrimaryButton
          split
          iconProps={{ iconName: "Add" }}
          text="New invoice"
          onClick={() => billing.ui.showInvoiceDetailsDialog(contactId)}
          menuProps={{
            items: getBillingMenuItems()
          }}
        />
      </Stack>
    );
  }
);
